import React from "react";
import { MUpdatePrice } from "../../../../../../server/routes/logUpdated/price/types";
import usePageLogUpdatedPriceContext from "../../Provider/hooks/usePageLogUpdatedPriceContext";

const useButtonShowLog = (logId: MUpdatePrice["id"]) => {
  const { showLog, isLoading } = usePageLogUpdatedPriceContext();

  return {
    isDisabled: isLoading.value,
    handlerClick: (e: React.MouseEvent<HTMLElement>) => {
      showLog.update(logId);
      e.stopPropagation();
    },
  };
};

export default useButtonShowLog;
